module.exports = "/shifts/components/calendarHeader/calendarHeaderDay-18ac6c.html";